/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_FixedInputs */

const en_whats_new_fixed = /** @type {(inputs: Whats_New_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed`)
};

const de_whats_new_fixed = /** @type {(inputs: Whats_New_FixedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behoben`)
};

/**
* | output |
* | --- |
* | "Fixed" |
*
* @param {Whats_New_FixedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_fixed = /** @type {((inputs?: Whats_New_FixedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_FixedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_whats_new_fixed(inputs)
	return en_whats_new_fixed(inputs)
});